import cx from 'classnames'
import * as React from 'react'

import { search, times } from '../../icons'
import type { NavigationLogoViewModel } from '../../view-models/NavigationLogoViewModel'
import type { SearchBarViewModel } from '../../view-models/SearchBarViewModel'
import type { ServiceMenuItemViewModel } from '../../view-models/ServiceMenuItemViewModel'
import type { ServiceMenuViewModel } from '../../view-models/ServiceMenuViewModel'
import BaseButton from '../BaseButton/BaseButton'
import Dropdown from '../Dropdown/Dropdown'
import DropdownLinks from '../DropdownLinks/DropdownLinks'
import Icon from '../Icon/Icon'
import Link from '../Link/Link'
import NavigationLogo from '../NavigationLogo/NavigationLogo'
import SearchBar from '../SearchBar/SearchBar'
import styles from './serviceMenuDesktop-style.css'

type Props = ServiceMenuViewModel & {
  renderLogo?: boolean
  logo: NavigationLogoViewModel
  searchBtn?: SearchBarViewModel
  onSubmit?: (...args: Array<any>) => any
}

type State = {
  isSearchOpen: boolean
}

class ServiceMenuDesktop extends React.Component<Props, State> {
  static displayName = 'ServiceMenuDesktop'
  static defaultProps = {}
  state = {
    isSearchOpen: false,
  }

  renderItem(item: ServiceMenuItemViewModel) {
    if (item.links) {
      return (
        <Dropdown
          name={'service-menu'}
          key={item.title}
          title={item.title}
          className={styles.serviceMenuDesktopItem}
        >
          <DropdownLinks items={item.links} position="left" />
        </Dropdown>
      )
    }

    return (
      <Link key={item.title} {...item.link} className={styles.serviceMenuDesktopItem} secondary>
        {item.link ? item.link.label : item.title}
      </Link>
    )
  }

  renderSearchBtn() {
    const { searchBtn } = this.props
    if (!searchBtn) return null

    return (
      <BaseButton
        className={styles.searchTrigger}
        onClick={() =>
          this.setState({
            isSearchOpen: true,
          })
        }
      >
        <Icon iconSrc={search} width="14px" height="14px" className={styles.icon} />
        <span>{searchBtn.triggerText}</span>
      </BaseButton>
    )
  }

  render() {
    const { links, logo, searchBtn, onSubmit } = this.props
    const { isSearchOpen } = this.state
    if (!links) return null

    return (
      <div className={styles.serviceMenuDesktop}>
        <NavigationLogo {...logo} className={styles.logo_small} />
        <div className={styles.menu}>
          {links.map(this.renderItem)}
          {this.renderSearchBtn()}
          <div className={cx(styles.searchComp, isSearchOpen ? styles.show : styles.hide)}>
            <div className={styles.searchBg}>
              <div className={styles.container}>
                {/*<NavigationLogo {...logo} className={styles.logo_small} />*/}
                <SearchBar searchBtn={searchBtn} onSubmit={onSubmit} isSearchOpen={isSearchOpen} />
                <BaseButton
                  className={styles.closeSearch}
                  onClick={() =>
                    this.setState({
                      isSearchOpen: false,
                    })
                  }
                >
                  {searchBtn && <span>{searchBtn.closeText}</span>}
                  <Icon iconSrc={times} width="6px" height="24px" className={styles.closeIcon} />
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ServiceMenuDesktop